import type { FC } from 'react';
import { Card } from 'components/enmon/card';
import { type CardProps, Empty, type EmptyProps } from 'antd';

interface NoCustomerContentProps {
  cardProps?: CardProps;
  emptyProps?: EmptyProps;
}

export const FallbackContent: FC<NoCustomerContentProps> = ({ cardProps, emptyProps }) => (
  <Card {...cardProps}>
    <Empty {...emptyProps} />
  </Card>
);
